import Body from '../Body/Body';
import DashedLine from './DashedLine';
import InfoModule from './InfoModule';
import Speaker from './Speaker';
import EventOverviewComponent from './EventOverviewComponent';
import { Event } from '../../app/(main)/events/[slug]/page.val';

const EventComponent = ({
  location,
  introduction,
  main,
  program,
  signup,
  speakers,
  date,
  events,
  eventFull,
  slug,
}: Event & {
  events: (Event & { slug: string })[];
  numberInSeries?: number;
  slug: string;
}) => {
  return (
    <>
      <div className="flex flex-row px-[20px] laptop:px-[50px] desktop:px-[150px] justify-center">
        <div className="flex flex-row w-full max-w-[1260px]">
          <div className="flex flex-col w-full gap-8 ">
            <section className="flex flex-col gap-10 py-[30px] laptop:px-[30px] desktop:px-[30px]">
              <Body
                richText={introduction}
                size={'large'}
                className={
                  ' text-[18px] tablet:text-[18px] laptop:text-[22px] desktop:text-[22px] '
                }
              />
            </section>
            <section className="flex flex-col gap-10 py-[30px] laptop:px-[30px] desktop:px-[30px]">
              <div className="mb-[calc(-2.5rem+10px)] laptop:mb-0 desktop::mb-0">
                <DashedLine className="bg-blank-yellow" />
              </div>
              <div className="z-10 laptop:hidden desktop:hidden">
                <InfoModule
                  program={program}
                  date={new Date(date)}
                  location={location}
                  eventUrl={signup?.url ?? undefined}
                  signupOpen={!!signup?.opens}
                  signupOpens={
                    signup?.opens ? new Date(signup.opens) : undefined
                  }
                  eventFull={eventFull}
                />
              </div>
              {speakers && (
                <div className="flex flex-col gap-5 mt-[32px]">
                  {speakers.map((speaker, idx) => (
                    <Speaker
                      key={idx}
                      name={speaker.name}
                      roles={speaker.roles || []}
                      speakerImage={speaker.speakerImage}
                    />
                  ))}
                </div>
              )}
              <Body
                richText={main}
                className={
                  ' text-[16px] tablet:text-[16px] laptop:text-[18px] desktop:text-[18px]'
                }
              />
            </section>
          </div>
          <div className="hidden laptop:block laptop:relative mt-[-100px] ml-[40px] right-0 z-10">
            <InfoModule
              program={program}
              date={new Date(date)}
              location={location}
              eventUrl={signup?.url ?? undefined}
              signupOpen={signup ? true : undefined}
              signupOpens={signup?.opens ? new Date(signup.opens) : undefined}
              eventFull={eventFull}
            />
          </div>
        </div>
      </div>

      <div className="flex flex-row  laptop:px-[50px] desktop:px-[150px] justify-center">
        <div className="flex flex-col max-w-[1260px] w-full gap-[130px] tablet:gap-[130px] laptop:gap-[160px] desktop:gap-[160px]">
          <div className="w-full flex flex-col gap-4 laptop:gap-[0px] desktop:gap-[0px]">
            <DashedLine className=" my-[5px] bg-blank-yellow" />
          </div>
        </div>
      </div>

      <EventOverviewComponent
        events={events}
        withinEvent
        currentEventSlug={slug}
      />
    </>
  );
};

export default EventComponent;
